/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Pending_Document_RequestsInputs */

const en_no_pending_document_requests = /** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pending document requests`)
};

const id_no_pending_document_requests = /** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada permintaan dokumen tertunda`)
};

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const es_no_pending_document_requests = en_no_pending_document_requests;

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const fr_no_pending_document_requests = en_no_pending_document_requests;

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const de_no_pending_document_requests = en_no_pending_document_requests;

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const ja_no_pending_document_requests = en_no_pending_document_requests;

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const zh_no_pending_document_requests = en_no_pending_document_requests;

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const ar_no_pending_document_requests = en_no_pending_document_requests;

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const it_no_pending_document_requests = en_no_pending_document_requests;

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const ru_no_pending_document_requests = en_no_pending_document_requests;

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const pt_no_pending_document_requests = en_no_pending_document_requests;

/** @type {(inputs: No_Pending_Document_RequestsInputs) => LocalizedString} */
const ko_no_pending_document_requests = en_no_pending_document_requests;

/**
* | output |
* | --- |
* | "No pending document requests" |
*
* @param {No_Pending_Document_RequestsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_pending_document_requests = /** @type {((inputs?: No_Pending_Document_RequestsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Pending_Document_RequestsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_pending_document_requests(inputs)
	if (locale === "es") return es_no_pending_document_requests(inputs)
	if (locale === "fr") return fr_no_pending_document_requests(inputs)
	if (locale === "de") return de_no_pending_document_requests(inputs)
	if (locale === "ja") return ja_no_pending_document_requests(inputs)
	if (locale === "zh") return zh_no_pending_document_requests(inputs)
	if (locale === "ar") return ar_no_pending_document_requests(inputs)
	if (locale === "id") return id_no_pending_document_requests(inputs)
	if (locale === "it") return it_no_pending_document_requests(inputs)
	if (locale === "ru") return ru_no_pending_document_requests(inputs)
	if (locale === "pt") return pt_no_pending_document_requests(inputs)
	return ko_no_pending_document_requests(inputs)
});